import {SafeRichTextRenderer} from "../common/richText/SafeRichTextRenderer";

export const MatchContent = ({text}) => {
    return (
        <SafeRichTextRenderer text={text} />
    )
}
